import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { select, Store } from '@ngrx/store';
import { BaseAppState } from '../../store/reducers';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AUTH_UI_PATHS } from '../definitions/auth-ui-navigation.definitions';
import { AuthSelectors } from '../selectors/auth.selectors';

@Injectable()
export class DeveloperGuard implements CanActivate {
  isDeveloper$ = this.store.pipe(select(AuthSelectors.getIsDeveloper));

  constructor(private router: Router, private store: Store<BaseAppState>) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.isDeveloper$.pipe(
      take(1),
      map((isDeveloprt) => {
        if (!isDeveloprt) {
          const redirectUrlTree = this.router.createUrlTree([AUTH_UI_PATHS.root.login]);
          return redirectUrlTree;
        }
        return true;
      })
    );
  }
}
